import React, { useState } from 'react';
import { Menu, X, Phone, Lightbulb } from 'lucide-react';
const NAV_LINKS = [{
  label: 'Services',
  href: '#services'
}, {
  label: 'Why Us',
  href: '#why-us'
}, {
  label: 'Gallery',
  href: '#gallery'
}, {
  label: 'Reviews',
  href: '#reviews'
}, {
  label: 'Service Area',
  href: '#service-area'
}];
const PHONE = '(480) 555-0147';
const PHONE_HREF = 'tel:+14805550147';
export function Header() {
  const [open, setOpen] = useState(false);
  return <header className="sticky top-0 z-50 w-full border-b border-border bg-background/95 backdrop-blur" data-id="element-93" data-mp="2rkb634dhiimj">
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8" data-id="element-94" data-mp="31bysurz3jbho">
        <a href="#top" className="flex items-center gap-2" aria-label="Outdoor Landscape Lighting home" data-id="element-95" data-mp="36b1xwcf2thpn">
          <Lightbulb className="h-7 w-7 text-accent" aria-hidden="true" data-id="element-96" data-mp="3baekqx5y6os8" />
          <span className="font-display text-xl leading-none text-foreground sm:text-2xl" data-id="element-97" data-mp="3b81xc4hf7m7s">
            Outdoor <span className="text-accent" data-id="element-98" data-mp="3f9nbdt5oy6jk">Landscape</span> Lighting
          </span>
        </a>

        <nav className="hidden items-center gap-7 lg:flex" aria-label="Primary" data-id="element-99" data-mp="2wirpdpzd2ps2">
          {NAV_LINKS.map(link => <a key={link.href} href={link.href} className="text-sm font-semibold uppercase tracking-wide text-muted-foreground transition-colors hover:text-foreground" data-id="element-100" data-mp="2mmopkqrzf38a">
              {link.label}
            </a>)}
        </nav>

        <div className="hidden items-center gap-4 lg:flex" data-id="element-101" data-mp="3ac9858k83yh1">
          <a href="#contact" className="rounded-md bg-accent px-5 py-2.5 font-display text-base tracking-wide text-accent-foreground transition-transform hover:scale-105" data-id="element-102" data-mp="3acre4wwotr25">
            Free Quote
          </a>
          <a href={PHONE_HREF} className="flex items-center gap-2 text-accent" data-id="element-103" data-mp="1wftz0dd6z35">
            <Phone className="h-5 w-5" aria-hidden="true" data-id="element-104" data-mp="1yadca8zmj54" />
            <span className="font-display text-lg" data-id="element-105" data-mp="3tabq53ecsv5c">{PHONE}</span>
          </a>
        </div>

        <button type="button" className="text-foreground lg:hidden" onClick={() => setOpen(v => !v)} aria-label={open ? 'Close menu' : 'Open menu'} aria-expanded={open} data-id="element-106" data-mp="1remfknrws8ia">
          {open ? <X className="h-7 w-7" data-id="element-107" data-mp="1hlno8y5123uz" /> : <Menu className="h-7 w-7" data-id="element-108" data-mp="1mml5n8i7qtvf" />}
        </button>
      </div>

      {open && <div className="border-t border-border bg-background lg:hidden" data-id="element-109" data-mp="18n3c6ftz2sfq">
          <nav className="flex flex-col px-4 py-4" aria-label="Mobile" data-id="element-110" data-mp="18ls9ykg6dsqq">
            {NAV_LINKS.map(link => <a key={link.href} href={link.href} onClick={() => setOpen(false)} className="py-3 text-sm font-semibold uppercase tracking-wide text-muted-foreground" data-id="element-111" data-mp="1cmc55ih6uma8">
                {link.label}
              </a>)}
            <div className="mt-3 flex flex-col gap-3" data-id="element-112" data-mp="2t13vzqyorlhf">
              <a href="#contact" onClick={() => setOpen(false)} className="rounded-md bg-accent px-5 py-3 text-center font-display text-base text-accent-foreground" data-id="element-113" data-mp="2y0p0egwmkm1j">
                Free Quote
              </a>
              <a href={PHONE_HREF} className="flex items-center justify-center gap-2 text-accent" data-id="element-114" data-mp="w4pudy6d901e">
                <Phone className="h-5 w-5" aria-hidden="true" data-id="element-115" data-mp="rdhk6zx7pan6" />
                <span className="font-display text-lg" data-id="element-116" data-mp="rbwov832pno9">{PHONE}</span>
              </a>
            </div>
          </nav>
        </div>}
    </header>;
}